<template>
	<div class="page-main" v-if="shoppingCart">
		<div class="page-head">
			<nav-bar title="购物车" :border="false" :left-arrow="true" @click-left="pageBack">
			</nav-bar>
			<div class="store-wrap">
				<div class="store-info">
					<div class="label">
						<span class="icon"></span>
						<span>自取门店</span>
					</div>
					<div class="store-name text-ellipsis">{{ store.name }}</div>
					<div class="store-address text-ellipsis">{{ store.address }}</div>
				</div>
				<div class="select-time">
					<div @click="qc = false">
						<radio v-model="qc" :name="false" class="radio" checked-color="#00af66" />
						<img class="icon" src="~@/assets/icon1.png" />
						<div class="text">
							<div>即刻取单</div>
							<p>2-5分钟领取</p>
						</div>
					</div>

					<div style="text-align: right" @click="openTimePicker">
						<div class="text">
							<div>选择取单时间</div>
							<p class="jt">{{ menu_time_desc || "选择时间" }}</p>
						</div>

						<img class="icon" src="~@/assets/icon2.png" />

						<radio v-model="qc" :name="true" class="radio" checked-color="#00af66" />
					</div>
				</div>
			</div>
		</div>
		<div class="page-body" ref="scrollDom">
			<div>
				<div class="cart-list">

					<div class="title-row">
						<div>我的订单</div>
						<div class="clear-cart" @click="ClearCart">

							<img src="~@/assets/del.png" alt="购物车">
						</div>
					</div>
					<no-list v-if="shoppingCart['Shopping_Cart'].length == 0" text="购物车是空的"></no-list>

					<div class="cart-item" v-for="item in cartList" :key="item['name']">
						<div class="goods-img">
							<img :src="item['default_image']" alt="" />
						</div>

						<div class="goods-content">
							<div class="goods-name">{{ item["name"] }}</div>
							<div class="goods-foot">
								<div class="price">￥{{ item["price"] / 100 }}</div>

								<div>
									<stepper v-model="item['qty']" :min="0" disable-input @plus="delGoods(item, 1)"
										@minus="delGoods(item, -1)" />
								</div>
							</div>
						</div>
					</div>

					<div v-if="outCartList.length > 0" class="failure-goods-box">
						<div>失效商品</div>
						<div class="cart-item" v-for="(item, index) in outCartList" :key="index">
							<div class="goods-img">
								<img :src="item['default_image']" alt="" />
							</div>

							<div class="goods-content">
								<div class="goods-name">{{ item["name"] }}</div>
								<div class="goods-foot">
									<div class="price">￥{{ item["price"] / 100 }}</div>

									<div>
										<stepper v-model="item['qty']" :min="0" disable-input @plus="delGoods(item, 1)"
											@minus="delGoods(item, -1)" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="page-foot">
			<div class="left">
				实付:<span>￥{{ total_price }}</span>
			</div>
			<div v-if="shoppingCart['Shopping_Cart'].length == 0" class="right-btn disabled">
				确认下单
			</div>
			<div v-else class="right-btn" @click="toOrder">确认下单</div>
		</div>

		<popup get-container="body" position="bottom" v-model="showTime" style="height: 50%" @close="showTime = false">
			<picker title="选择取单时间" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showTime = false" />
		</popup>
	</div>
</template>
<script>
	import {
		navBar,
		stepper,
		Radio,
		popup,
		picker
	} from "vant";
	import {
		timeLists,
		ClearShoppingCart
	} from "@/api";
	import {
		mapGetters
	} from "vuex";
	import noList from "@/components/noList";
	import BScroll from "@better-scroll/core";

	export default {
		data() {
			return {
				qc: false,
				time: null,
				menu_time_desc: null,
				columns: [],
				showTime: false,
			};
		},

		mounted() {



			this.$store.dispatch("getShoppingCart").then(() => {
				this.$nextTick(() => {
					this.leftScroll = BScroll(this.$refs["scrollDom"], {
						click: true,
					});
				});
			});
		},

		computed: {
			...mapGetters({
				shoppingCart: "getShoppingCart",
				store: "getStore",
			}),

			cartList() {
				return this.shoppingCart["Shopping_Cart"].filter((d) => {
					return d["out_of_shelf"] == 0;
				});
			},
			outCartList() {
				return this.shoppingCart["Shopping_Cart"].filter((d) => {
					return d["out_of_shelf"] != 0;
				});
			},
			total_price() {
				if (this.shoppingCart) {
					return this.shoppingCart["total_price"] / 100;
				} else {
					return 0;
				}
			},
		},
		methods: {

			openTimePicker() {
				var store = this.$store.getters.getStore;

				timeLists(store.id).then((d) => {
					var list = d.data.date_time_list;
					this.columns = list.map((d) => {
						return {
							text: d.time_list_title,
							children: d.time_list.map((time) => {
								return {
									text: time.hour.value,
									children: time.minutes.map((m) => {
										return {
											...m,
											text: m.value,
										};
									}),
								};
							}),
						};
					});
				});

				this.showTime = true;
			},
			ClearCart() {
				ClearShoppingCart().then((d) => {

					console.log(d)
					this.$store.dispatch("delallShoppingCart");


					this.$router.push({
						name: "shopping"

					});


				})

			},
			onConfirm(v, indexs) {
				this.showTime = false;
				this.qc = true;
				var item =
					this.columns[indexs[0]].children[indexs[1]].children[indexs[2]];
				this.menu_time_desc = item.menu_time_desc;
				this.time = item.expect_date;
			},
			pageBack() {
				window.history.back();
			},
			toOrder() {
				if (this.outCartList.length > 0) {
					this.$msg("请删除失效商品");
					return;
				}

				if (this.qc) {
					this.$router.push({
						name: "order",
						query: {
							time: this.time,
							timeStr: this.menu_time_desc
						},
					});
				} else {
					this.$router.push({
						name: "order",
					});
				}
			},
			delGoods(item, num) {
				this.$store.dispatch("reduceShoppingCart", {
					data: item,
					num: num,
				});
			},



		},
		components: {
			picker,
			popup,
			Radio,
			navBar,
			stepper,
			noList,
		},
	};
</script>

<style lang="scss" scoped>
	.page-main {
		background: #f1f1f1;
		height: 100vh;
		display: flex;
		flex-direction: column;

		.page-body {
			flex: 1;
			min-height: 1;
			overflow: hidden;

			&>div {
				overflow: hidden;
			}
		}
	}

	.page-head {
		color: #fff;
		background: rgb(40, 40, 40);

		::v-deep .van-nav-bar__content {
			background: rgb(40, 40, 40);
			color: #fff;

			.van-nav-bar__title,
			.van-icon {
				color: #fff;
			}
		}
	}

	.store-wrap {
		padding: 20px 30px;

		.store-info {
			position: relative;
			border-bottom: 1px solid rgba(255, 255, 255, 0.2);
			padding-bottom: 10px;

			.label {
				color: #999;
				font-size: 24px;

				.icon {
					background-image: url(~@/assets/order_icon_map.png);
					background-repeat: no-repeat;
					background-size: contain;
					background-position: center;
					width: 24px;
					height: 26px;
					display: inline-block;
					margin-right: 6px;
				}
			}

			.store-name {
				font-size: 28px;
			}

			.store-address {
				font-size: 24px;
				transform: scale(0.83);
				transform-origin: left;
			}
		}

		.select-time {
			display: flex;
			justify-content: space-between;
			margin-top: 20px;

			&>div {
				display: flex;
				align-items: center;
				font-size: 24px;
				position: relative;

				&::after {
					content: "";
					position: absolute;
					left: 0;
					top: 0;
					width: 100%;
					height: 100%;
					z-index: 10;
				}

				.icon {
					width: 70px;
					height: 70px;
					margin: 0 10px;
				}

				.text {
					line-height: 1.2;

					div {
						color: #999;
						margin-bottom: 6px;
					}

					p {
						margin: 0;

						&.jt::after {
							content: "";
							width: 10px;
							height: 10px;
							display: inline-block;
							border-bottom: 1px solid #fff;
							border-left: 1px solid #fff;
							transform: rotate(-45deg);
							transform-origin: left;
							margin-left: 10px;
						}
					}
				}
			}
		}
	}

	.cart-list {
		margin: 24px;
		padding: 0 20px 20px 20px;
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
		border-radius: 8px;
		background: #fff;



		.title-row {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 88px;
			line-height: 88px;
			border-bottom: 1px solid #f1f1f1;
			font-weight: bold;
		}

		.title {
			font-size: 28px;
		}

		.clear-cart {
			background-color: transparent;
			padding: 0;
			border: none;
			cursor: pointer;
			display: flex;
			align-items: center;
		}

		.clear-cart img {
			margin-right: 8px;
			height: 30px;
			width: 30px;
		}


		.cart-item {
			display: flex;
			align-items: center;
			padding: 20px 0;

			.goods-img {
				width: 100px;
				height: 100px;
				border-radius: 50%;
				margin-right: 30px;
				position: relative;

				img {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					display: block;
					z-index: 5;
					object-fit: contain;
				}

				&::after {
					content: "";
					position: absolute;
					left: 50%;
					top: 50%;
					width: 80px;
					height: 80px;
					background: #d8db3c;
					border-radius: 50%;
					z-index: 1;
					transform: translate(-50%, -50%);
				}
			}

			.goods-content {
				flex: 1;

				.goods-name {
					font-size: 30px;
					font-weight: bold;
				}

				.goods-foot {
					display: flex;
					align-items: center;

					.price {
						flex: 1;
						font-weight: bold;
					}

					img {
						width: 55px;
						height: 55px;
					}
				}
			}
		}
	}

	.failure-goods-box {
		color: #ddd;
	}

	.page-foot {
		padding: 16px 30px;
		width: 100%;
		background: #fff;
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
		z-index: 50;
		display: flex;
		box-sizing: border-box;
		margin-left: 0 !important;

		.left {
			flex: 1;
			line-height: 80px;
			font-size: 28px;

			span {
				color: #1f623f;
				font-weight: bold;
				font-size: 32px;
			}
		}

		.right-btn {
			width: 400px;
			height: 80px;
			line-height: 80px;
			text-align: center;
			background: #00af66;
			color: #fff;
			border-radius: 40px;
			font-size: 32px;
			letter-spacing: 2px;

			&.disabled {
				background: #dddddd;
			}
		}
	}

	.h {
		height: 120px;
	}
</style>